module.exports = __webpack_public_path__ + "img/SoftwareGroup.8c7f7bba.jpg";